import React, { useEffect, useState } from 'react';
import { Checkbox } from '@progress/kendo-react-inputs';
import { Tooltip } from '@progress/kendo-react-tooltip';

function CompanyTaxInfoFields({ onChange, showErrors = false, initialValue = {} }) {

    const [state, setState] = useState({
        isCompany: false,
        companyName: "",
        gstNumber: ""
    })

    const [focusedFields, setFocusedFields] = useState({
        companyName: false,
        gstNumber: false
    })

    useEffect(() => {
        if (Object.keys(initialValue).length > 0) {
            const isCompany = true;
            setState(prevState => ({
                ...prevState,
                isCompany,
                ...initialValue
            }))
        }
    }, [])

    useEffect(() => {
        onChange(state)
    }, [state])

    function handleChange(e) {
        const { name, value } = e.target;
        setState(prevState => ({
            ...prevState,
            [name]: value
        }))
    }

    function handleBlur(e) {
        const { name } = e.target;
        setFocusedFields(prevFields => ({
            ...prevFields,
            [name]: showErrors
        }))
    }

    return (
        <div>
            <div className='col-12 mt-1'>
                <Checkbox
                    checked={state.isCompany}
                    value={state.isCompany}
                    label="Are you a company?"
                    onChange={() => setState(prevState => ({
                        ...prevState,
                        isCompany: !state.isCompany
                    }))} />
            </div>
            {
                state.isCompany &&
                <div className='col-12'>
                    <label className='form-label' htmlFor='company-name-field'>
                        Company Name
                        {
                            focusedFields.companyName &&
                            !state.companyName?.trim() &&
                            <span className='text-danger'>
                                &nbsp;This field is required
                            </span>
                        }
                    </label>
                    <input
                        id="company-name-field"
                        name="companyName"
                        className='form-control'
                        value={state.companyName}
                        onChange={handleChange}
                        onBlur={handleBlur} />
                </div>
            }
            {
                state.isCompany &&
                <div className='col-12'>
                    <label className='form-label' htmlFor='gst-hst-field'>
                        GST/HST Number
                        {
                            focusedFields.gstNumber &&
                            !state.gstNumber?.trim() &&
                            <span className='text-danger'>
                                &nbsp;This field is required
                            </span>
                        }
                    </label>
                    {
                        state.gstNumber &&
                        !/[0-9]{9}(RC|RM|RP|RT)[0-9]{4}/g.test(state.gstNumber) &&
                        <span className='text-danger'>
                            {" "}GST number is invalid.
                        </span>
                    }
                    <div className='input-group'>
                        <input
                            id="gst-hst-field"
                            name="gstNumber"
                            className='form-control'
                            value={state.gstNumber}
                            onChange={handleChange}
                            onBlur={handleBlur} />
                        <span className='input-group-text'>
                            <Tooltip position='right' anchorElement='target'>
                                <i
                                    title='15-digit characters e.g. 123456789RT0001'
                                    className='fa-regular fa-info-circle' />
                            </Tooltip>
                        </span>
                    </div>
                </div>
            }
        </div>
    )
}

export default CompanyTaxInfoFields;